import React from 'react'

interface OpenEndedQuestionProps {
  body: string
  required: boolean
  questionId?: number | string
  readOnly?: boolean
  onChange?: (value: string) => void
}

const OpenEndedQuestion: React.FC<OpenEndedQuestionProps> = ({ body, questionId, readOnly = false, onChange }) => {
  return (
    <div className="question-container">
      <div className="question-body mb-3">
        <p className="font-bold text-gray-800">{body}</p>
      </div>

      <div className="answer-field">
        {readOnly ? (
          <div className="border border-gray-300 rounded-lg h-16 w-full bg-gray-50"></div>
        ) : (
          <>
            <label htmlFor={`open-ended-textarea-${questionId ?? ''}`} className="sr-only">
              {body}
            </label>
            <textarea
              id={`open-ended-textarea-${questionId ?? ''}`}
              className="w-full p-2 border border-gray-300 rounded-lg h-16"
              autoComplete="off"
              onChange={e => onChange?.(e.target.value)}
            />
          </>
        )}
      </div>
    </div>
  )
}

export default OpenEndedQuestion
